export const DEFLECT_ANALYTICS_SLICE_NAME = "deflectAnalytics"

// One key per block of data in the store. A card and its "View All" page share a key when they
// make the same request (each refetches it on its own window); where the page asks for something
// else (paging, search, filters) it gets a key of its own, so neither ever shows the other's rows.
export const DEFLECT_SECTION = {
  KPIS: "kpis",
  TREND: "trend",
  QUEUE: "queue",
  FLOW: "flow",
  BY_CHANNEL: "byChannel",
  BY_COUNTRY: "byCountry",
  BY_PROGRAM: "byProgram",
  MATCH_RATE_MATRIX: "matchRateMatrix",
  REPEAT_CARDHOLDERS: "repeatCardholders",
  REPEAT_CARDHOLDERS_PAGE: "repeatCardholdersPage",
  CHANNEL_TRENDS: "channelTrends",
  LOOKUPS: "lookups",
  LOOKUP_ACTIVITY: "lookupActivity"
}
